import ClientConfigApp from "SystemConfiguration/App";
import {
  type RouteObject,
} from "react-router";
import { SystemSettingsMenuPage } from "SettingsMenuPage/SettingsMenuPage";

declare let viewModel: any;

export const systemSettingsRoute: RouteObject = {
  path: "systemsettings",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: SystemSettingsMenuPage,
  }, {
    path: "config",
    loader: () => viewModel,
    Component: ClientConfigApp,
  }]
};